import $ from 'jquery';
import UI from 'root/ui';
import Cache from 'root/cache';
import Router from 'root/router';
import Modals from 'root/modals';
import Modal from 'root/module/modal';
import Form from 'root/module/form';
import View from 'view/base';

export default View.extend({
    events: {
        'click .open-portal'              : 'onOpenPortal',
        'input input[name="subdomain"]'   : 'onChangeSubdomain',
        'keydown input[name="subdomain"]' : 'onBeforeEnterSubdomain',
        'keyup input[name="subdomain"]'   : 'onAfterEnterSubdomain',
        'click .portal-domain-add'        : 'onFocusDomain',
        'click .subdomain-save'           : 'onSaveSubdomain',
        'input input[name="portal_name"]' : 'onChangeName',
        'click .name-save'                : 'onSaveName',
        'click .approval-portal-toggle'   : 'onToggle',
        'click .approval-widget-toggle'   : 'onToggle',
        'click .feature-requests-toggle'  : 'onToggle',
        'click .roadmap-toggle'           : 'onToggle',
        'click .announcement-toggle'      : 'onToggle',
        'click .feedback-import'          : 'onImport',
        'click .feedback-import-cancel'   : 'onImportCancel',
        'click .portal-delete'            : 'onDeletePortal',
    },

    dom_handlers: {
        onImport: function(e) {
            this.$el.find('.feedback-import').addClass('loading').prop('disabled', true);

            // fake progress
            this.$el.find('.setup .meteor-success').show();

            var progress = 0;

            var animate = () => {
                progress += 5;
                this.$el.find('.setup .meteor-success span').width(progress + '%');

                if (progress < 100) {
                    setTimeout(animate, Math.random() * 100);
                } else {
                    UI.success('Ideas published to your portal');

                    setTimeout(() => {
                        this.$el.find('.setup').remove();
                    }, 1000);
                }
            };

            Cache.app.request({
                action: 'portal/setupPublish',
                context: this,
                success: function() {
                    setTimeout(animate, Math.random() * 100);
                }
            });
        },

        onImportCancel: function(e) {
            this.$el.find('.setup').remove();
        },

        onOpenPortal: function(e) {
            e.preventDefault();
            window.open(this.model.getUrl(), 'portal');
        },

        onFocusDomain: function(e) {
            this.$el.find('.input[name="subdomain"]').focus();
        },

        onBeforeEnterSubdomain: function(e) {
            if (!e.key.match(/[a-zA-Z0-9-]/)) {
                e.preventDefault();
                return;
            }
        },

        onAfterEnterSubdomain: function(e) {
            if (e.keyCode === 13) {
                // Enter
                this.$el.find('.subdomain-save:visible').click();
            }
        },

        onChangeSubdomain: function(e) {
            var subdomain = $(e.currentTarget).val().trim();

            var subdomain_sanitised = subdomain.replace(/[^a-zA-Z0-9-]/g, '').replace(/[-]{2,}/g, '-').toLowerCase();

            if (subdomain !== subdomain_sanitised) {
                $(e.currentTarget).val(subdomain_sanitised);
            }

            if (!subdomain_sanitised) {
                this.$el.find('.portal-subdomain-save').hide();
                this.$el.find('.url-taken').hide();
                this.$el.find('.url-validation').html('');
                return;
            }

            if (subdomain_sanitised !== this.model.get('subdomain')) {
                clearTimeout(this.subdomain_timeout);
                this.subdomain_timeout = setTimeout(() => {
                    this.checkSubdomain(subdomain_sanitised);
                }, 100);
            }
        },

        onSaveSubdomain: function(e) {
            Modal.open({
                title: 'Confirm',
                content: '<p>Are you sure you want to change the portal url? Once changed the old url will no longer work.</p>',
                context: this,
                button: {
                    'Yes, change': function() {
                        Modal.close();

                        var subdomain = this.$el.find('input[name="subdomain"]').val().trim().toLowerCase();

                        this.$el.find('.subdomain-save').addClass('loading').prop('disabled', true);

                        Cache.app.request({
                            action: 'portal/saveSubdomain',
                            data: {
                                portal_id : this.model.id,
                                subdomain : subdomain
                            },
                            context: this,
                            success: function() {
                                this.model.set('subdomain', subdomain);
                                this.$el.find('.portal-subdomain-save').hide();
                                this.$el.find('.url-validation').html('<i class="far fa-check text-success"></i>');

                                Modal.close();
                                UI.success('Portal url updated');
                            },
                            complete: function() {
                                this.$el.find('.subdomain-save').removeClass('loading').prop('disabled', false);
                            }
                        });
                    }
                }
            });
        },

        onChangeName: function(e) {
            var portal_name = $(e.currentTarget).val();

            this.$el.find('.portal-name-save').toggle(portal_name !== this.model.get('portal_name'));
        },

        onSaveName: function() {
            this.$el.find('.portal-name-save').hide();
            this.saveSettings();
        },

        onToggle: function(e) {
            if ($(e.currentTarget).hasClass('switch-on')) {
                $(e.currentTarget).addClass('switch-off').removeClass('switch-on');
            } else {
                $(e.currentTarget).addClass('switch-on').removeClass('switch-off');
            }

            this.saveSettings();
        },

        onDeletePortal: function() {
            Modals.deletePortal(this.model.id);
        }
    },

    checkSubdomain: function(subdomain) {
        this.$el.find('.url-validation').html('<i class="far fa-sync-alt fa-spin text-info"></i>');

        Cache.app.request({
            action: 'portal/checkSubdomain',
            data: {
                subdomain: subdomain
            },
            context: this,
            success: function(response) {
                if (response.result === true) {
                    this.$el.find('.url-validation').html('');
                    this.$el.find('.url-taken').hide();
                    this.$el.find('.portal-subdomain-save').show();
                } else {
                    this.$el.find('.url-validation').html('<i class="far fa-times text-danger"></i>');
                    this.$el.find('.url-taken').show();
                    this.$el.find('.portal-subdomain-save').hide();
                }
            }
        });
    },

    saveSettings: function() {
        var form_data = Form.getData(this.$el.find('.general'));

        this.$el.find('button:submit').addClass('loading').prop('disabled', true);

        Cache.app.request({
            action: 'portal/update',
            data: {
                portal_id            : this.model.id,
                portal_name          : form_data.portal_name,
                has_feature_requests : this.$el.find('.feature-requests-toggle').hasClass('switch-on'),
                has_roadmap          : this.$el.find('.roadmap-toggle').hasClass('switch-on'),
                has_announcement     : this.$el.find('.announcement-toggle').hasClass('switch-on'),
                approve_portal       : this.$el.find('.approval-portal-toggle').hasClass('switch-on'),
                approve_widget       : this.$el.find('.approval-widget-toggle').hasClass('switch-on')
            },
            context: this,
            success: function(response) {
                this.model.set(response);
                UI.success('Portal settings updated');
            }
        });
    },

    onRender: function() {
        var query_string = Router.getQueryString();

        if (query_string.setup) {
            Cache.app.request({
                action: 'portal/setupCheck',
                context: this,
                success: function(response) {
                    if (response.unpublished > 0) {
                        this.$el.find('.unpublished-total').text(response.unpublished + ' idea' + (response.unpublished === 1 ? '' : 's'));
                        this.$el.find('.setup').show();
                    }
                }
            });
        }
    },

    render: function() {
        var query_string = Router.getQueryString();

        var content =
        (query_string.setup ?
        '<div class="setup box box-nopadding" style="display:none;">' +
            '<div class="padding-32">' +
                '<h3>Publish ideas</h3>' +
                '<div>' +
                    '<div class="text-info text-medium">We found <span class="unpublished-total"></span> in this project. Would you like to publish them to the ideas portal?</div>' +
                '</div>' +
                '<div class="meteor-success margin-top-24" style="display:none;"><div><span style="width:0%;"></span></div></div>' +
                '<div class="text-align-right margin-top-24">' +
                    '<button type="button" class="feedback-import-cancel tertiary small margin-right-12">No, I will do it later on the feedback page</button>' +
                    '<button type="button" class="feedback-import primary small">Yes, publish</button>' +
                '</div>' +
            '</div>' +
        '</div>' : '') +

        '<div class="general box box-nopadding">' +
            '<div class="grid-4-8 grid-none-mobile padding-32">' +
                '<div>' +
                    '<h3 class="margin-top-12">Portal URL</h3>' +
                '</div>' +
                '<div>' +
                    '<div class="portal-domain-add input-subdomain">' +
                        '<div>' +
                            '<span class="url-validation"><i class="far fa-check text-success"></i></span>' +
                            '<span class="subdomain">' +
                                '<input type="text" name="subdomain" maxlength="50" data-validation="string" placeholder="mycompany">' +
                            '</span>' +
                            '<span class="host-name">' + Cache.app.configs.portal_host + '</span>' +
                        '</div>' +
                    '</div>' +
                    '<div class="text-danger text-medium margin-top-8 float-left url-taken">This url is already taken</div>' +
                    '<div class="portal-subdomain-save text-align-right margin-top-12" style="display:none;">' +
                        '<button type="button" class="subdomain-save primary small">Save Changes</button>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            '<hr class="xsmall">' +

            '<div class="grid-4-8 grid-none-mobile padding-32">' +
                '<div>' +
                    '<h3 class="margin-top-12">Portal name</h3>' +
                '</div>' +
                '<div>' +
                    '<input type="text" class="solid medium" name="portal_name" maxlength="100" placeholder="Ideas">' +
                    '<div class="portal-name-save text-align-right margin-top-12" style="display:none;">' +
                        '<button type="button" class="name-save primary small">Save Changes</button>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            '<hr class="xsmall">' +

            '<div class="padding-32 flex-between-top">' +
                '<div>' +
                    '<h3>Ideas</h3>' +
                    '<div class="text-info text-medium">Collect ideas publicly in the ideas portal and let people vote on existing ideas.</div>' +
                '</div>' +
                '<div>' +
                    '<button type="button" class="feature-requests-toggle small ' + (this.model.get('has_feature_requests') ? 'switch-on' : 'switch-off') + '"></button>' +
                '</div>' +
            '</div>' +

            '<hr class="xsmall">' +

            '<div class="padding-32 flex-between-top">' +
                '<div>' +
                    '<h3>Roadmap</h3>' +
                    '<div class="text-info text-medium">Add roadmap to your ideas portal.</div>' +
                '</div>' +
                '<div>' +
                    '<button type="button" class="roadmap-toggle small ' + (this.model.get('has_roadmap') ? 'switch-on' : 'switch-off') + '"></button>' +
                '</div>' +
            '</div>' +

            '<hr class="xsmall">' +

            '<div class="padding-32 flex-between-top">' +
                '<div>' +
                    '<h3>Announcements</h3>' +
                    '<div class="text-info text-medium">Add announcements to your ideas portal.</div>' +
                '</div>' +
                '<div>' +
                    '<button type="button" class="announcement-toggle small ' + (this.model.get('has_announcement') ? 'switch-on' : 'switch-off') + '"></button>' +
                '</div>' +
            '</div>' +

            '<hr class="xsmall">' +

            '<div class="padding-32">' +
                '<h3>Moderation</h3>' +
                '<div class="text-info text-medium">Automatically publish ideas to the ideas portal when they are submitted from:</div>' +

                '<div class="divider-24"></div>' +

                '<div class="flex-between-top">' +
                    '<div class="font-weight-medium">Ideas Portal</div>' +
                    '<button type="button" class="approval-portal-toggle small ' + (this.model.get('approve_portal') ? 'switch-on' : 'switch-off') + '"></button>' +
                '</div>' +

                '<div class="divider-12"></div>' +

                '<div class="flex-between-top">' +
                    '<div class="font-weight-medium">Widget, Browser Extension & Email</div>' +
                    '<button type="button" class="approval-widget-toggle small ' + (this.model.get('approve_widget') ? 'switch-on' : 'switch-off') + '"></button>' +
                '</div>' +
            '</div>' +

            '<button type="submit" class="hidden">Submit</button>' +
        '</div>' +

        '<div class="form-fluid">' +
            '<div class="field-label">Danger Zone</div>' +
            '<div class="box box-nopadding form-fluid">' +
                '<div class="grid-8-4 grid-none-mobile padding-32">' +
                    '<div>' +
                        '<h3>Delete ideas portal</h3>' +
                        '<div class="text-info text-medium">No longer need the ideas portal?</div>' +
                    '</div>' +
                    '<div class="text-align-right">' +
                        '<button type="button" class="portal-delete small min secondary">Delete</button>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        Form.setData(this.$el.find('.general'), {
            portal_name : this.model.get('portal_name'),
            subdomain   : this.model.get('subdomain')
        });

        this.onRender();

        return this;
    }
});